import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { environment } from '@environments/environment';
import { CurrentUserV2Interface } from '@interfaces/current-user-v2.interface';

/**
 * current user http service
 */
@Injectable({
  providedIn: 'root',
})
export class CurrentUserHttpService {
  constructor(private httpClient: HttpClient) {}

  /**
   * get current user details
   */
  getCurrentUser(): Observable<CurrentUserV2Interface> {
    const url = `${environment.apiHostV2}/members/current`;

    return this.httpClient.get<CurrentUserV2Interface>(url).pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  /**
   * update current user details
   * @param user - current user details
   */
  updateCurrentUser(user: Partial<CurrentUserV2Interface>): Observable<CurrentUserV2Interface> {
    const url = `${environment.apiHostV2}/members/current`;

    return this.httpClient.put<CurrentUserV2Interface>(url, user).pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }
}
